var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeechToText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3333 6.58847V7.84337C12.3333 9.00824 11.8417 10.1254 10.9665 10.9491C10.0913 11.7728 8.90434 12.2355 7.66667 12.2355C6.42899 12.2355 5.242 11.7728 4.36683 10.9491C3.49167 10.1254 3 9.00824 3 7.84337V6.58847M7.66797 12.2355V14.7453M5 14.7502H10.3333M7.66797 0.941406C7.13754 0.941406 6.62883 1.13972 6.25375 1.49273C5.87868 1.84574 5.66797 2.32453 5.66797 2.82376V7.84337C5.66797 8.3426 5.87868 8.82138 6.25375 9.17439C6.62883 9.5274 7.13754 9.72572 7.66797 9.72572C8.1984 9.72572 8.70711 9.5274 9.08218 9.17439C9.45726 8.82138 9.66797 8.3426 9.66797 7.84337V2.82376C9.66797 2.32453 9.45726 1.84574 9.08218 1.49273C8.70711 1.13972 8.1984 0.941406 7.66797 0.941406Z",
    stroke: "#606060",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechToText);
export default __webpack_public_path__ + "static/media/speechToText.7734ecd9c6493111da1939f5ed20a866.svg";
export { ForwardRef as ReactComponent };